import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MailTemplateKind } from '@skylab-shared/dataModel';
import { Mutable } from '@skylab-shared/types';

export type MailTemplateItem = Omit<MailTemplateInternalItem, 'version'>;

type MailTemplateInternalItem = {
    readonly version: string;
    readonly id: number;
    readonly default: boolean;
    readonly kind: MailTemplateKind;
    readonly name: string;
    readonly senderName: string;
    readonly subjectPattern: string;
    readonly messagePattern: string;
};

export class MailTemplateQuery extends Query<MailTemplateItem[]> { }

export class MailTemplateQueryHandlerBase implements QueryHandler<MailTemplateQuery, MailTemplateItem[]> {

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: MailTemplateQuery): Promise<MailTemplateItem[]> {
        const url = TaggedUrl.join('system/emailPatterns', [Tags.Api]);
        const { data } = await this.http.get<Mutable<{ items: MailTemplateInternalItem[] }>>(url);
        return data.items.map(i => {
            return {
                id: i.id,
                default: i.default,
                kind: i.kind,
                name: i.name,
                senderName: i.senderName,
                subjectPattern: i.subjectPattern,
                messagePattern: i.messagePattern,
                version: i.version
            };
        });
    }
}
